/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type InvestmentExportStatusEnum = 'pending' | 'accepted' | '11184809';

export const InvestmentExportStatusEnum = {
  PENDING: 'pending' as InvestmentExportStatusEnum,
  ACCEPTED: 'accepted' as InvestmentExportStatusEnum,
  UNKNOWN_DEFAULT_OPEN_API: '11184809' as InvestmentExportStatusEnum
};
